// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Lu6fg","span":"NotFoundBlock_span__24VYv","description":"NotFoundBlock_description__bXsdq"};